import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const browsImages = [{
  url: 'https://cdn.magicpatterns.com/uploads/vrh1DD46USV1y7WzneuBeG/Laminado_de_cejitas_✨_asi_de_hermosas_quedan_❤️browlamination_lamibrows_studio_beautystudio_.jpg',
  alt: 'Laminado de cejas — resultado natural y definido'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/8peN7poYsJJszkR4j787Tx/Laminado,_un_rotundo_yesss_🫰🏻❤️_🔥Si_todavia_no_te_animaste_a_probarlo,_no_se_que_estas_espera.jpg',
  alt: 'Laminado de cejas con diseño y perfilado'
}];
export function BrowsGallery() {
  return <section id="brows-gallery" className="w-full py-20 px-4 bg-white" data-id="element-18">
      <div className="max-w-6xl mx-auto" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <p className="text-gold font-semibold tracking-widest uppercase text-sm mb-3" data-id="element-21">
            Cejas & Pestañas
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-4" data-id="element-22">
            Galería de Cejas y Pestañas
          </h2>
          <p className="text-charcoal/70 max-w-2xl mx-auto" data-id="element-23">
            Laminados, diseño y perfilado que realzan tu mirada de forma natural
          </p>
          <div className="flex items-center justify-center gap-4 mt-6" data-id="element-24">
            <div className="w-16 h-0.5 bg-gold" data-id="element-25" />
            <div className="w-2 h-2 bg-gold rotate-45" data-id="element-26" />
            <div className="w-16 h-0.5 bg-gold" data-id="element-27" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-28">
          {browsImages.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative aspect-square md:aspect-[4/5] overflow-hidden rounded-2xl shadow-lg shadow-pink/30 hover:shadow-2xl transition-shadow group" data-id="element-29">
              <img src={image.url} alt={image.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-30" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-31" />
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-32">
          <a href="https://vrbeautystudio.koob.uy" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-gold text-white font-semibold rounded-full hover:bg-gold/90 transition-colors shadow-lg hover:shadow-xl" data-id="element-33">
            Reservar turno
            <ArrowRight className="w-4 h-4" data-id="element-34" />
          </a>
        </div>
      </div>
    </section>;
}